<section id="environment-settings">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-9">
        <div class="row">
          <h1>Environment</h1>
        </div>
        <div *ngIf="environments$ | async as environments; else loading">
          <div class="row add">
            <div *ngIf="environments.length == 0">
              No environments to display.
            </div>
            <button
              themeColor="primary"
              size="medium"
              (click)="newEnvironment()"
              kendoButton
            >
              New <span>+</span>
            </button>
          </div>
          <kendo-card
            *ngFor="let environment of environments$ | async"
            width="100%"
            orientation="vertical"
          >
            <div class="k-vstack">
              <kendo-card-header>
                <div class="k-hstack card-actions">
                  <h5 kendoCardTitle class="link">
                    {{ environment.name }}
                  </h5>
                  <div>
                    <button
                      kendoButton
                      (click)="editEnvironment(environment)"
                      themeColor="primary"
                      fillMode="outline"
                      icon="pencil"
                    ></button>
                    <button
                      class="ml-2"
                      routerLink="{{ environment.id }}/tool"
                      kendoButton
                      themeColor="primary"
                    >
                      Add Tool
                    </button>
                    <button
                      kendoButton
                      class="ml-2"
                      (click)="deleteEnvironment(environment)"
                      themeColor="primary"
                      fillMode="outline"
                      icon="trash"
                    ></button>
                  </div>
                </div>
                <h6 kendoCardSubtitle>{{ environment.description }}</h6>
              </kendo-card-header>
              <kendo-card-body width="100%">
                <div class="unknown">
                  <div *ngFor="let tool of environment.tools" class="k-hstack">
                    <img
                      class="mr-3"
                      height="30px"
                      width="30px"
                      [src]="getToolIcon(tool.product)"
                    />
                    <div>
                      <span
                        routerLink="{{ environment.id }}/tool/{{ tool.id }}"
                        class="link"
                        >{{ tool.name }}</span
                      >
                      <p>{{ tool.product }}</p>
                    </div>
                  </div>
                  <div *ngIf="environment.tools.length == 0">
                    No tools to display.
                  </div>
                </div>
              </kendo-card-body>
            </div>
          </kendo-card>
        </div>
        <ng-template #loading>
          <div class="loading">
            <kendo-loader type="pulsing" themeColor="primary" size="large">
            </kendo-loader>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</section>
<router-outlet></router-outlet>
